import React from "react";
import RadioGroup from "../../../components/common/RadioGroup";
import DateTimePicker from "../../../components/common/DateTimePicker";
import { CalendarIcon, ClockIcon } from "@heroicons/react/outline";

const CampaignScheduleStep = ({ data, onChange }) => {
  const scheduleOptions = [
    {
      value: "now",
      label: "Send Immediately",
      description: "Campaign will start sending right away",
    },
    {
      value: "scheduled",
      label: "Schedule for Later",
      description: "Choose a specific date and time",
    },
  ];

  const handleScheduleTypeChange = (value) => {
    onChange({
      ...data,
      sendNow: value === "now",
      scheduledTime: value === "now" ? null : data.scheduledTime,
    });
  };

  const handleDateTimeChange = (dateTime) => {
    onChange({
      ...data,
      scheduledTime: dateTime,
    });
  };

  const minDateTime = new Date();
  minDateTime.setMinutes(minDateTime.getMinutes() + 5); // Minimum 5 minutes from now

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-4">
        <CalendarIcon className="w-5 h-5 text-gray-600" />
        <h3 className="font-semibold">Delivery Schedule</h3>
      </div>

      <RadioGroup
        name="schedule"
        options={scheduleOptions}
        value={data.sendNow ? "now" : "scheduled"}
        onChange={handleScheduleTypeChange}
      />

      {!data.sendNow && (
        <div className="mt-6">
          <DateTimePicker
            label="Scheduled Date & Time"
            value={data.scheduledTime}
            onChange={handleDateTimeChange}
            min={minDateTime}
            required
          />

          {/* Quiet Hours Warning */}
          {data.scheduledTime && (
            <div className="mt-4">
              {(() => {
                const scheduledHour = new Date(data.scheduledTime).getHours();
                const isQuietHours = scheduledHour >= 21 || scheduledHour < 8;
                
                if (isQuietHours) {
                  return (
                    <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
                      <div className="flex">
                        <ClockIcon className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                        <div className="ml-3">
                          <h4 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                            Quiet Hours Notice
                          </h4>
                          <p className="mt-1 text-sm text-yellow-700 dark:text-yellow-300">
                            This campaign is scheduled during quiet hours (9 PM - 8 AM).
                            Promotional notifications will be queued until 8 AM.
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                }
                
                return (
                  <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4">
                    <p className="text-sm text-green-800 dark:text-green-200">
                      ✓ Scheduled outside quiet hours
                    </p>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      )}

      {/* Time Zone Notice */}
      <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong>Note:</strong> All times are in IST (India Standard Time).
          The campaign will be delivered based on each user's local timezone
          settings if available.
        </p>
      </div>
    </div>
  );
};

export default CampaignScheduleStep;
